/*
 * Copyright (c) 2024-2026, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

// Some platforms draw scrollbars *over* the content (Firefox and Chromium with
// overlay scrollbars on Windows 11 / macOS). A list that scrolls inside a card
// then has its right-aligned values (percentages, times, statuses) under the
// bar. A classic scrollbar takes its own column and needs nothing.
//
// This marks the scrolling lists that really overflow AND whose scrollbar
// takes no space, so CSS can give just those a right-hand gutter:
//   [data-sb-overlay] { padding-right: 14px }

const SELECTOR = [
  ".gh-proc", ".gh-disk", ".gh-up", ".gh-ev", ".gh-qa", ".gh-prob-list", ".gh-inc-list",
  ".cc-plist", ".cc-scroll", ".cc-cell--qa", ".sv-scroll", "div.sv-table", ".rt-scroll",
  ".modal-scrollbar", ".hub-devices", ".dkr-env", ".dkr-attn",
  '[class*="overflow-y-auto"]', '[class*="overflow-auto"]',
].join(",");

function update(el: HTMLElement) {
  const overflows = el.scrollHeight > el.clientHeight + 1;
  const style = getComputedStyle(el);
  const scrolls = /(auto|scroll)/.test(style.overflowY);
  const border = parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);
  const overlay = el.offsetWidth - el.clientWidth - border < 1;
  const want = overflows && scrolls && overlay;
  if (want !== el.hasAttribute("data-sb-overlay")) el.toggleAttribute("data-sb-overlay", want);
}

export function installScrollPad(): void {
  if (typeof document === "undefined") return;
  let queued = false;
  const run = () => {
    queued = false;
    document.querySelectorAll<HTMLElement>(SELECTOR).forEach(update);
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(run);
  };
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  window.addEventListener("resize", schedule);
  // lists grow as data arrives without any DOM mutation we can see cheaply
  window.setInterval(schedule, 2000);
  schedule();
}
